/** Malayalam UI strings (merged over English in translations.js). */
export const rawMl = {
  nav: {
    home: "ഹോം",
    database: "തട്ടിപ്പുകാരുടെ ഡാറ്റാബേസ്",
    recovery: "വീണ്ടെടുക്കൽ പ്രക്രിയ",
    risk: "റിസ്ക് പരിശോധന",
    redFlags: "ചുവന്ന പതാകകൾ",
    education: "അവബോധം",
    stories: "യഥാർത്ഥ കഥകൾ",
    about: "ഞങ്ങളെക്കുറിച്ച്",
    contact: "ബന്ധപ്പെടുക",
    legalHelp: "നിയമ സഹായം",
    reportCta: "നഷ്ടം റിപ്പോർട്ട്",
    mentors: "മെന്റർമാർ",
    dashboard: "ഡാഷ്‌ബോർഡ്",
    signIn: "സൈൻ ഇൻ",
    signOut: "സൈൻ ഔട്ട്",
  },
  common: {
    reportScam: "നഷ്ടം റിപ്പോർട്ട് ചെയ്യുക",
    learnRecovery: "പരാതി പ്രക്രിയ അറിയുക",
    confidential: "100% രഹസ്യം",
    readMore: "കൂടുതൽ വായിക്കുക",
    backHome: "ഹോമിലേക്ക് മടങ്ങുക",
    search: "തിരയുക",
    verified: "സ്ഥിരീകരിച്ചത്",
    anonymous: "അജ്ഞാത",
    submit: "സമർപ്പിക്കുക",
    cancel: "റദ്ദാക്കുക",
    requiredField: "ആവശ്യം",
    check: "ഇപ്പോൾ പരിശോധിക്കുക",
    loading: "ലോഡ് ചെയ്യുന്നു…",
    error: "എന്തോ തെറ്റായി. വീണ്ടും ശ്രമിക്കുക.",
  },
  hero: {
    eyebrow: "ഇന്ത്യയുടെ തെളിവ്-ആധാരിത സാമ്പത്തിക പരാതി മാർഗദർശനം",
    title1: "സാമ്പത്തിക നഷ്ടത്തിനെ",
    title2: "എതിർക്കുക.",
    subtitle:
      "ട്രേഡിംഗ് തട്ടിപ്പ് മുതൽ ബാങ്കിംഗ്, സൈബർ, ഇൻഷുറൻസ്, എയർലൈൻ, ഉപഭോക്താവ്, ഹൗസിംഗ് ഫിനാൻസ്, പെൻഷൻ തർക്കങ്ങൾ വരെ — ശരിയായ അധികാരം, ശരിയായ തെളിവ്, അധികൃത ഇന്ത്യൻ പരാതി സംവിധാനത്തിൽ ശരിയായ അടുത്ത ഘട്ടം.",
    reportBtn: "സാമ്പത്തിക നഷ്ടം റിപ്പോർട്ട് ചെയ്യുക",
    recoveryBtn: "പരാതി പ്രക്രിയ അറിയുക",
    taglines: ["ശരിയായ അധികാരം കണ്ടെത്തുക.", "ശരിയായ തെളിവ് തയ്യാറാക്കുക.", "ശരിയായ അടുത്ത ഘട്ടം എടുക്കുക."],
  },
  report: {
    title: "അജ്ഞാതമായി റിപ്പോർട്ട് ചെയ്യുക",
    subtitle: "നിങ്ങളുടെ ഐഡന്റിറ്റി പൂർണ്ണമായും രഹസ്യമാണ്. പ്രസിദ്ധീകരിക്കുന്നതിന് മുമ്പ് ഓരോ റിപ്പോർട്ടും പരിശോധിക്കപ്പെടും.",
    scamType: "നഷ്ടത്തിന്റെ തരം",
    amountLost: "നഷ്ടപ്പെട്ട തുക (₹)",
    platform: "ഉപയോഗിച്ച പ്ലാറ്റ്‌ഫോം",
    telegram: "ടെലിഗ്രാം യൂസർനെയിം (ഉണ്ടെങ്കിൽ)",
    upi: "UPI ID (ഉണ്ടെങ്കിൽ)",
    phone: "ഫോൺ നമ്പർ (ഉണ്ടെങ്കിൽ)",
    company: "കമ്പനി / ഉപദേഷ്ടാവിന്റെ പേര്",
    website: "വെബ്‌സൈറ്റ് URL",
    description: "എന്ത് സംഭവിച്ചു — വിശദമായി എഴുതുക",
    contact: "ഇമെയിൽ (ഓപ്ഷണൽ)",
    uploadEvidence: "തെളിവ് അപ്‌ലോഡ്",
    uploadHelp: "സ്ക്രീൻഷോട്ടുകൾ, PDF, പേയ്‌മെന്റ് തെളിവ്, ചാറ്റ് എക്സ്‌പോർട്ട്. ഫയലിന് 10MB.",
    submit: "സുരക്ഷിതമായി സമർപ്പിക്കുക",
    successTitle: "റിപ്പോർട്ട് സമർപ്പിച്ചു",
    successDesc: "നന്ദി. 72 മണിക്കൂറിനുള്ളിൽ ഞങ്ങളുടെ ടീം തെളിവ് പരിശോധിക്കും. നിങ്ങളുടെ ഐഡന്റിറ്റി രഹസ്യമായി തുടരും.",
    disclaimer: "എല്ലാ ആരോപണത്തിനും തെളിവ് ആവശ്യമാണ്. തെറ്റായ റിപ്പോർട്ടുകൾ നിരസിക്കപ്പെടാം.",
  },
  education: {
    eyebrow: "പഠിക്കുക · സംരക്ഷിക്കുക · വീണ്ടെടുക്കുക",
    title: "അവബോധ കേന്ദ്രം",
    subtitle: "ഇന്ത്യൻ നിക്ഷേപകർക്ക് തട്ടിപ്പ് അവബോധവും നിയമ മാർഗദർശനവും.",
    readMinutes: "മിനിറ്റ് വായന",
    filterAll: "എല്ലാം",
    emptyCategory: "ഈ വിഭാഗത്തിൽ ഇതുവരെ ലേഖനങ്ങളില്ല.",
  },
  blog: {
    eyebrow: "അന്വേഷണം · കഥകൾ · മാർഗദർശികൾ",
    title: "ബ്ലോഗ് — യഥാർത്ഥ കേസുകൾ, നിയമ മാർഗം",
    subtitle: "സ്ഥിരീകരിച്ച പീഡിത അനുഭവങ്ങളും നിയമ പരാതി ഘട്ടങ്ങളും.",
    allStories: "എല്ലാ കഥകളും",
    featured: "പ്രധാനം",
    readFull: "പൂർണ്ണം വായിക്കുക",
    readArticle: "പൂർണ്ണ ലേഖനം",
    collapse: "ചുരുക്കുക",
    emptyCategory: "ഈ വിഭാഗത്തിൽ ഇതുവരെ ലേഖനങ്ങളില്ല.",
    newBadge: "പുതിയത്",
  },
  footer: {
    tagline: "കേൾക്കുന്നതിനേക്കാൾ തെളിവ്. മൗനത്തേക്കാൾ സുരക്ഷ.",
    sections: { platform: "പ്ലാറ്റ്‌ഫോം", legal: "നിയമം", connect: "ബന്ധം" },
    links: {
      privacy: "സ്വകാര്യതാ നയം",
      terms: "ഉപയോഗ നിബന്ധനകൾ",
      disclaimer: "നിരാകരണം",
      antiHarassment: "ഉത്പീഡന-വിരോധ നയം",
      dataDeletion: "ഡാറ്റ ഇല്ലാതാക്കൽ അഭ്യർത്ഥന",
    },
    disclaimer: "CHINTAMAT സാമ്പത്തിക ഉപദേശം നൽകുന്നില്ല. വീണ്ടെടുക്കലിന് guarantee നൽകുന്നില്ല.",
    rights: "© 2026 CHINTAMAT. പൊതുഹിത ആന്റി-സ്കാം മിഷൻ.",
  },
  stats: {
    reports: "സ്ഥിരീകരിച്ച പരാതികൾ",
    scammers: "ട്രാക്ക് ചെയ്ത തട്ടിപ്പുകാർ",
    cases: "പരിഹരിച്ച കേസുകൾ",
    loss: "റിപ്പോർട്ട് ചെയ്ത നഷ്ടം",
  },
};

export const appStringsMl = {
  lang: { choose: "ഭാഷ തിരഞ്ഞെടുക്കുക" },
  auth: {
    welcomeBack: "വീണ്ടും സ്വാഗതം",
    signInSubtitle: "റിവ്യൂകൾ, കേസ് ട്രാക്ക്, മെന്റർമാർ സേവ് ചെയ്യാൻ സൈൻ ഇൻ ചെയ്യുക.",
    joinTitle: "CHINTAMAT-ൽ ചേരുക",
    joinSubtitle: "സ്കാം റിപ്പോർട്ട്, നിയമ സഹായം, മെന്റർ ഡയറക്ടറിക്ക് അക്കൗണ്ട് തുറക്കുക.",
    email: "ഇമെയിൽ",
    password: "പാസ്‌വേഡ്",
    name: "പൂർണ്ണ പേര്",
    signIn: "സൈൻ ഇൻ",
    signUp: "അക്കൗണ്ട് തുറക്കുക",
    continueGoogle: "Google ഉപയോഗിച്ച് തുടരുക",
    orEmail: "അല്ലെങ്കിൽ ഇമെയിൽ",
    newHere: "CHINTAMAT-ൽ പുതിയവരാണോ?",
    haveAccount: "ഇതിനകം അക്കൗണ്ട് ഉണ്ടോ?",
    createAccount: "അക്കൗണ്ട് തുറക്കുക",
    gotoSignIn: "സൈൻ ഇൻ",
    passwordMin: "പാസ്‌വേഡ് കുറഞ്ഞത് 6 അക്ഷരങ്ങൾ",
    roleUser: "വ്യക്തിഗത",
    roleUserDesc: "ട്രേഡർ / പീഡിതൻ — റിപ്പോർട്ട് അല്ലെങ്കിൽ ഗവേഷണത്തിന്.",
    roleMentor: "മെന്റർ / അധ്യാപകൻ",
    roleMentorDesc: "കോഴ്സ്, ചാനൽ അല്ലെങ്കിൽ paid mentorship നടത്തുന്നു.",
    roleAdvisory: "ഗവേഷണ വിശകലനക്കാരൻ / ഉപദേഷ്ടാവ്",
    roleAdvisoryDesc: "SEBI രജിസ്റ്റർ ചെയ്ത RIA, RA അല്ലെങ്കിൽ ഫirm.",
    verifying: "സെഷൻ പരിശോധന…",
    adminRequired: "അഡ്മിൻ പ്രവേശനം ആവശ്യമാണ്.",
  },
  dashboard: {
    eyebrow: "എന്റെ ഡാഷ്‌ബോർഡ്",
    hello: "നമസ്കാരം",
    adminPanel: "അഡ്മിൻ പാനൽ",
    adminDesc: "ഉപയോക്താക്കൾ, സ്കാം റിപ്പോർട്ടുകൾ, നിയമ സഹായം, ബ്ലോഗ് നിയന്ത്രിക്കുക.",
    openAdmin: "അഡ്മിൻ തുറക്കുക",
    statReviews: "എഴുതിയ റിവ്യൂകൾ",
    statCases: "റിപ്പോർട്ട് ചെയ്ത കേസുകൾ",
    statLegal: "നിയമ അഭ്യർത്ഥനകൾ",
    statSaved: "സേവ് ചെയ്ത മെന്റർമാർ",
    tabReviews: "എന്റെ റിവ്യൂകൾ",
    tabCases: "എന്റെ കേസുകൾ",
    tabSaved: "സേവ് ചെയ്ത മെന്റർമാർ",
    tabLegal: "നിയമ സഹായം",
    emptyReviews: "ഇതുവരെ റിവ്യൂകളില്ല.",
    browseMentors: "മെന്റർമാരെ കാണുക",
    emptyCases: "ഇതുവരെ കേസുകളില്ല.",
    reportScam: "നഷ്ടം റിപ്പോർട്ട്",
    emptySaved: "സേവ് ചെയ്ത മെന്റർമാർ ഇല്ല.",
    discoverMentors: "മെന്റർമാരെ കണ്ടെത്തുക",
    emptyLegal: "ഇതുവരെ നിയമ അഭ്യർത്ഥനകളില്ല.",
    submitLegal: "അഭ്യർത്ഥന അയയ്ക്കുക",
    viewProfile: "പ്രൊഫൈൽ",
    recentActivity: "സമീപകാല അപ്‌ഡേറ്റുകൾ",
    openCase: "കേസ് തുറക്കുക",
    prefsTitle: "അറിയിപ്പ് മുൻഗണനകൾ",
    prefsBlog: "പുതിയ ബ്ലോഗ്, അവബോധ ലേഖനങ്ങൾ",
    prefsCase: "കേസ് സ്ഥിതി, സ്റ്റാഫ് മറുപടി",
    prefsSaved: "മുൻഗണനകൾ സേവ് ചെയ്തു",
  },
  notifications: {
    title: "അറിയിപ്പുകൾ",
    empty: "ഇതുവരെ അറിയിപ്പുകളില്ല",
    markAllRead: "എല്ലാം വായിച്ചതായി അടയാളപ്പെടുത്തുക",
    viewDashboard: "ഡാഷ്‌ബോർഡ് തുറക്കുക",
    types: {
      case_status_change: { title: "{caseLabel} — സ്ഥിതി അപ്‌ഡേറ്റ്", body: "നിങ്ങളുടെ കേസ് ഇപ്പോൾ: {status}" },
      case_staff_comment: { title: "CHINTAMAT-ൽ നിന്ന് മറുപടി", body: "{authorName}: {preview}" },
      case_user_comment: { title: "ഉപയോക്താവിന്റെ അഭിപ്രായം — {caseLabel}", body: "{authorName}: {preview}" },
      new_scam_report: { title: "പുതിയ സ്കാം റിപ്പോർട്ട്", body: "{scamType}" },
      new_legal_request: { title: "പുതിയ നിയമ അഭ്യർത്ഥന", body: "{lossType} — {name}" },
      blog_published: { title: "പുതിയ ലേഖനം", body: "{articleTitle}" },
    },
  },
  caseWorkspace: {
    evidenceTitle: "തെളിവ് ചെക്ക്ലിസ്റ്റ്",
    statusTimeline: "സ്ഥിതി ടൈംലൈൻ",
    comments: "അഭിപ്രായങ്ങൾ",
    sendMessage: "സന്ദേശം അയയ്ക്കുക",
    postComment: "അഭിപ്രായം പോസ്റ്റ്",
    noComments: "ഇതുവരെ അഭിപ്രായങ്ങളില്ല. CHINTAMAT സ്റ്റാഫ് ഇവിടെ മറുപടി നൽകും.",
    userCommentHint: "നിങ്ങളുടെ സന്ദേശം CHINTAMAT സ്റ്റാഫിന് കാണാം.",
    staffCommentHint: "പൊതു അഭിപ്രായങ്ങൾ ഉപയോക്താവിന് കാണാം. ആന്തരിക കുറിപ്പുകൾ സ്റ്റാഫിന് മാത്രം.",
    publicVis: "പൊതു (ഉപയോക്താവ് കാണാം)",
    internalVis: "ആന്തരികം മാത്രം",
    loading: "കേസ് ലോഡ്…",
    notFound: "കേസ് കണ്ടെത്തിയില്ല",
    caseUpdated: "കേസ് അപ്‌ഡേറ്റ്",
    commentPosted: "അഭിപ്രായം പോസ്റ്റ് ചെയ്തു",
    checklist: {
      screenshots: "ചാറ്റ് അല്ലെങ്കിൽ സ്ക്രീൻഷോട്ട് തെളിവ്",
      payment_proof: "UPI / ബാങ്ക് പേയ്‌മെന്റ് തെളിവ്",
      platform_profile: "തട്ടിപ്പുകാരന്റെ പ്രൊഫൈൽ ലിങ്കുകൾ",
      contract: "ഇൻവോയ്സ് അല്ലെങ്കിൽ കരാർ",
    },
  },
  mentors: {
    title: "മെന്റർ ഡയറക്ടറി",
    subtitle: "പേയ്‌മെന്റിന് മുമ്പ് മെന്റർമാരെ പരിശോധിക്കുക. റിവ്യൂകൾ രജിസ്റ്റർ ചെയ്ത ഉപയോക്താക്കളിൽ നിന്ന് — SEBI രജിസ്ട്രേഷൻ independently verify ചെയ്യുക.",
    search: "പേര്, കമ്പനി, നഗരം തിരയുക…",
    category: "വിഭാഗം",
    allCategories: "എല്ലാ വിഭാഗങ്ങളും",
    verification: "സ്ഥിരീകരണം",
    all: "എല്ലാം",
    verifiedOnly: "സ്ഥിരീകരിച്ചവ മാത്രം",
    unverified: "സ്ഥിരീകരിക്കാത്ത",
    sortTrust: "ഏറ്റവും ഉയർന്ന വിശ്വാസം",
    sortReviews: "ഏറ്റവും കൂടുതൽ റിവ്യൂകൾ",
    sortRecent: "സമീപകാല",
    noResults: "മെന്റർമാർ കണ്ടെത്തിയില്ല.",
    viewProfile: "പ്രൊഫൈൽ",
    reviews: "റിവ്യൂകൾ",
  },
  protected: { loading: "സെഷൻ പരിശോധന…", adminLoading: "അഡ്മിൻ പരിശോധന…" },
};
